let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("97oXA")).then(() => parcelRequire('fvOWZ'));